import { icon } from "../functions/icons";

export function CheckRectangle({handleTextChange, handleCorrectChange, textValue, CorrectValue, HandleRemoveOption, allowAnswerDeletion, prefix}) {
    return (
        <>
            <div style={{"grid-template-columns": (allowAnswerDeletion ? "34.6px 1fr 34.6px" : "34.6px 1fr")}} className={`rectangle-grid ${CorrectValue ? "active-multiple-choice" : ""}`}>
                <div onClick={() => handleCorrectChange()} className={"correct-answer-box"}>
                    {CorrectValue ? icon("check") : ""}
                </div>
                <div className="horizontal" style={{"padding": "0.5rem 0rem 0.5rem 0.5rem"}}>
                    {prefix && <p className="small-standard-padding-left prefix-text">{prefix}</p>}
                    <input type="text" value={textValue} onChange={(e) => handleTextChange(e.target.value)} placeholder="Vul een antwoord in" className={`hidden-text-input ${!prefix ? "" : "standard-margin-left"}`}/>
                </div>
                {
                    allowAnswerDeletion &&
                    <div onClick={HandleRemoveOption}>
                        {icon("trash")}
                    </div>
                }
            </div>
        </>
    )
}